import "./PictureSlider.scss"

import React, { FunctionComponent, ReactNode, useState, useEffect } from "react"
import Spinner from "components/Spinner/Spinner"

interface IPictureSliderProps {
    imageUrl?: string
    hasPrev?: boolean
    hasNext?: boolean
    onPrev?(): void
    onNext?(): void
    additionalControls?: ReactNode
}

const PictureSlider: FunctionComponent<React.PropsWithChildren<IPictureSliderProps>> = ({
    imageUrl,
    hasPrev,
    hasNext,
    onPrev,
    onNext,
    additionalControls,
}) => {
    const [isLoadingImage, setIsLoadingImage] = useState(false)

    useEffect(() => {
        if (!imageUrl) {
            setIsLoadingImage(false)
            return
        }
        setIsLoadingImage(true)
        const img = new Image()
        img.onload = () => {
            setIsLoadingImage(false)
        }
        img.src = imageUrl
    }, [imageUrl])

    function handlePrevClick() {
        if (typeof onPrev !== "function") return
        onPrev()
    }

    function handleNextClick() {
        if (typeof onNext !== "function") return
        onNext()
    }

    return (
        <div className="picture-slider">
            {!!additionalControls &&
                <div className="picture-slider__additional-controls">
                    {additionalControls}
                </div>
            }
            <button
                type="button"
                data-testid="prev-btn"
                className="picture-slider__nav picture-slider__nav--prev"
                disabled={!hasPrev || !onPrev}
                onClick={handlePrevClick} />
            <div className="picture-slider__img-wrap">
                {isLoadingImage &&
                    <Spinner />
                }
                {!isLoadingImage &&
                    <img
                        src={imageUrl}
                        className="picture-slider__img"
                        data-testid="main-img"
                        alt="" />
                }
            </div>
            <button
                type="button"
                data-testid="next-btn"
                className="picture-slider__nav picture-slider__nav--next"
                disabled={!hasNext || !onNext}
                onClick={handleNextClick} />
        </div>
    )
}

export default PictureSlider
